import API from "./api";

// Create a new supervisor log
export const createSupervisorLog = async (logData) => {
    try {
        const response = await API.post("/supervisor/logs", logData);
        return response.data;
    } catch (error) {
        console.error("Error creating supervisor log:", error);
        throw error;
    }
};

// Get all supervisor logs
export const getSupervisorLogs = async (filters = {}) => {
    try {
        const response = await API.get("/supervisor/logs", { params: filters });
        return response.data;
    } catch (error) {
        console.error("Error fetching supervisor logs:", error);
        throw error;
    }
};

// Get a single supervisor log by ID
export const getSupervisorLogById = async (logId) => {
    try {
        const response = await API.get(`/supervisor/logs/${logId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching supervisor log:", error);
        throw error;
    }
};

// Update a supervisor log
export const updateSupervisorLog = async (logId, logData) => {
    try {
        const response = await API.put(`/supervisor/logs/${logId}`, logData);
        return response.data;
    } catch (error) {
        console.error("Error updating supervisor log:", error);
        throw error;
    }
};

// Delete a supervisor log
export const deleteSupervisorLog = async (logId) => {
    try {
        const response = await API.delete(`/supervisor/logs/${logId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting supervisor log:", error);
        throw error;
    }
};

// Get production statistics
export const getProductionStats = async (filters = {}) => {
    try {
        const response = await API.get("/supervisor/stats", { params: filters });
        return response.data;
    } catch (error) {
        console.error("Error fetching production stats:", error);
        throw error;
    }
};

// Generate production report
export const generateProductionReport = async (filters = {}) => {
    try {
        const response = await API.get("/supervisor/reports", { params: filters });
        return response.data;
    } catch (error) {
        console.error("Error generating production report:", error);
        throw error;
    }
};